import React from 'react'
import './AboutBanner.css'

const AboutBanner = () => {
    return (
        <div className="about-banner">
            <div className="about-banner-content">
                <h3 className="about-banner-h2">
                    Who we are
                </h3>
                <h4 className="about-banner-p">
                    Check out more about us.. 
                </h4>
            </div>
        </div>
    )
}

export default AboutBanner
